import { Container, Col, Row } from "react-bootstrap";
import Carousel from "react-multi-carousel"
import "react-multi-carousel/lib/styles.css";
import pythonImage from "../assets/image/python-icon.svg"
import javaImage from "../assets/image/java-icon.svg"
import htmlImage from "../assets/image/html-icon.svg"
import sqlImage from "../assets/image/sql-icon.svg"




export const Skills = () => {
    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 3000},
            items: 5
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024},
            items: 3
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 2
        },
        mobile: {
            breakpoint: { max: 464, min: 0},
            items: 1
        }
    };

    return (
        <section className="skill" id="skills">
            <Container>
                <Row>
                    <Col>
                        <div className="skill-bx">
                            <h2>
                                Skills
                            </h2>
                            
                            <Carousel responsive={responsive} infinite={true} className="skill-slider">
                                <div className="item">
                                    <img src={pythonImage} alt="image"/>
                                    <h5>Python</h5>
                                </div>
                                <div className="item">
                                    <img src={javaImage} alt="image"/>
                                    <h5>Java</h5>
                                </div>
                                <div className="item">
                                    <img src={sqlImage} alt="image"/>
                                    <h5>SQL</h5>
                                </div>
                                <div className="item">
                                    <img src={htmlImage} alt="image"/>
                                    <h5>HTML</h5>
                                </div>
                                
                            </Carousel>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}